import { render, staticRenderFns } from "./data65.vue?vue&type=template&id=7c68edb5&scoped=true&"
import script from "./data65.vue?vue&type=script&lang=js&"
export * from "./data65.vue?vue&type=script&lang=js&"
import style1 from "./data65.vue?vue&type=style&index=1&id=7c68edb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c68edb5",
  null
  
)

export default component.exports